module.exports = __webpack_public_path__ + "static/media/warning.8b5d86b1.svg";